import React from "react";
import Reveal from "./Reveal";
import { trackEvent } from "../../lib/track";

/**
 * Final CTA. Phase 1 plain-language version.
 *
 * The homepage ends in a single, low-friction decision: start with
 * the Snapshot (free), or step straight onto the Clarity Reset Session
 * if the visitor is ready for paid interpretation. Both buttons
 * route into existing flows. No personalization, no smart reorder,
 * no Book / Personal Action Plan cross-sells. Less is the point.
 */
const FinalCTA = () => {
  const onSnapshot = () => trackEvent("final_cta_snapshot_clicked");
  const onOrientation = () => {
    trackEvent("final_cta_orientation_reset_clicked");
    window.dispatchEvent(new CustomEvent("am:open-orientation-reset-checkout"));
  };

  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative py-28 md:py-36 border-t border-gold/10"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <p className="text-[11px] tracking-[0.5em] uppercase text-gold mb-6">
            Begin
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl leading-tight tracking-tight text-themed font-light">
            Start with what keeps{" "}
            <span className="italic gold-gradient-text">showing up.</span>
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <p className="mt-8 text-themed-muted text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
            You do not need the whole map yet. Begin with the pattern that keeps
            asking for your attention.
          </p>
        </Reveal>
        <Reveal delay={220}>
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="/frequency-snapshot"
              data-testid="final-cta-snapshot"
              onClick={onSnapshot}
              className="btn-gold"
            >
              Take the Free Clarity Snapshot
            </a>
            <button
              type="button"
              data-testid="final-cta-orientation-reset"
              onClick={onOrientation}
              className="btn-ghost-gold"
            >
              Book the Clarity Reset Session · $149
            </button>
          </div>
          <p
            data-testid="final-cta-snapshot-trust"
            className="mt-5 text-[11px] tracking-[0.3em] uppercase text-gold/80"
          >
            Get your result first. No email required.
          </p>
          <p
            data-testid="final-cta-reassurance"
            className="mt-6 text-themed-muted text-[14.5px] leading-relaxed max-w-md mx-auto"
          >
            You do not have to figure out your whole life today. Just start by seeing the pattern.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
